// extracted by mini-css-extract-plugin
module.exports = {"list-item":"item_list-item__LjbRt"};